import React, { ChangeEvent } from 'react';
import { FormField } from './FormField';
import styles from './FormSelect.module.css';

interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface FormSelectProps {
  label: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  required?: boolean;
  error?: string;
  helperText?: string;
  disabled?: boolean;
  className?: string;
}

export const FormSelect: React.FC<FormSelectProps> = ({
  label,
  name,
  value,
  onChange,
  options,
  placeholder = 'Select an option',
  required = false,
  error,
  helperText,
  disabled = false,
  className = '',
}) => {
  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  const isInvalid = !!error;

  return (
    <FormField
      label={label}
      required={required}
      error={error}
      helperText={helperText}
      className={className}
    >
      <select
        name={name}
        value={value}
        onChange={handleChange}
        required={required}
        disabled={disabled}
        className={`${styles.select} ${isInvalid ? styles.error : ''}`}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
    </FormField>
  );
};
